<template>
  <b-modal
    :visible="value"
    ref="confirm-sync-modal"
    centered
    no-close-on-backdrop
    hide-header
    @close="$emit('close')"
  >
  <div class="text-center mb-4px">
    <div class="modal-icon"><i class="fas fa-triangle-exclamation text-warning" style="font-size: 64px;"></i></div>
    <div class="text-title fw-500">Sync Update {{ data.title }}</div>
    <div class="text-grey-600 fw-400">
      <div>Do you want to sync and update file {{ data.title }}?</div>
      <div>You can’t undo this action</div>
    </div>
  </div>
    <template v-slot:modal-footer="{close}">
      <div class="d-flex justify-content-center w-100" style="gap:8px">
        <button type="button" class="btn btn-light" @click="close">
          Cancel
        </button>
        <button type="button" class="btn bg-warning" @click="sync">
          Sync Update
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
export default {
  name: 'ConfirmSyncUpdateModal',
  emits: ['sync', 'close'],
  components: { BModal },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    data: { type: Object,
      required: true }
  },
  methods: {
    sync () {
      this.$emit('sync')
    },
    close
  }
}
</script>

<style scoped>
.modal-icon {
  margin-bottom: 1.5rem;
}
.text-title {
  color:#0D173C;
  margin-bottom:1rem;
  font-size:20px;
}
.mb-4px {
  margin-bottom:4px;
}
</style>
